import { IOption } from "Dashboard/domain/IOption";
import { forwardRef, useEffect, useState } from "react";
import Select from "react-select";
import { styles } from "./SelectStyle";
import { IAverageConsumption } from "../domain/IAverageConsumption";
import { averageConsumption } from "../helpers/resourceUtil";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";

const AverageConsumptionSelect = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const [value, setValue] = useState<IOption | undefined>(undefined);

  useEffect(() => {
    function getData() {
      if (props.resourceListItem.averageConsumptions?.length > 0) {
        const op = props.resourceListItem.averageConsumptions.map((consumption: IAverageConsumption, index: number) => {
          return {
            label: FormatDateShort(consumption.timeFrom) + ' - ' + FormatDateShort(consumption.timeTo) + ' - ' + FormatNumberWithUnitOrNull(consumption.distance, consumption.usageUnit.name) + ' - ' + calcAverageConsumption(consumption),
            value: index + 1,
            isDisabled: true
          }
        });
        setOptions(op);
        setValue(op[0]);
        setIsLoading(false);
      } else {
        setOptions([]);
        setIsLoading(false);
      }
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, [props.resourceListItem]);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const calcAverageConsumption = (consumption: IAverageConsumption) => {
    let avrgConsumption = averageConsumption(
      consumption
    ).split(" ");

    return avrgConsumption[0] + " " + avrgConsumption[1];
  };


  return (
    <Select
      isClearable={false}
      styles={styles.averageConsumptionStyles}
      ref={ref}
      options={options}
      value={value}
      onChange={handleChange}
      placeholder={""}
      loadingMessage={() => "Učitavanje..."}
      noOptionsMessage={() => ""}
      isLoading={isLoading}
      {...{ error: props.error }}
      components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
    />
  );
});

export default AverageConsumptionSelect;
